import { API } from './axios-config'

export default {
	get: function (callback, error) {
		console.debug('get')

		API.get('v1/products')
			.then(response => {
				// JSON responses are automatically parsed.
				console.debug(response)

				var areDataValid = false

				if (response.data) {
					if (response.data.products) {
						areDataValid = true

						var result = []
						response.data.products.forEach(function (item) {
							if (result.indexOf(item) < 0) {
								result.push(item)
							}
						})

						callback(result)
					}
				}

				if (!areDataValid) {
					error(e)
				}
			})
			.catch(e => {
				console.debug(e)

				error(e)
			})
	}
}
